(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["menu-list"] && !Shopify.designMode) return;
  try {
    // main header nav items
  document.querySelectorAll('nav > ul.list-menu:not(.header__submenu) > li > a.header__menu-item').forEach(headerLink => headerLink.addEventListener('click', (e) => {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'header_menu',
      'header_category': e.currentTarget.dataset.category ? e.currentTarget.dataset.category.trim() : e.currentTarget.dataset.category
    });
  }))

  // submenu items
  document.querySelectorAll('ul.header__submenu li a.header__menu-item').forEach(headerLink => headerLink.addEventListener('click', (e) => {
    const linkEl = e.currentTarget || (e.target && e.target.closest && e.target.closest('a.header__menu-item'));
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'header_menu',
      'header_category': linkEl && linkEl.dataset.parentCategory ? linkEl.dataset.parentCategory.trim() : linkEl && linkEl.dataset.parentCategory,
      'header_subcategory': linkEl && linkEl.dataset.subcategory ? linkEl.dataset.subcategory.trim() : linkEl && linkEl.dataset.subcategory
    });
  }))
  } catch(e) { console.error(e); }
})();

})();
